import { Translate } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";

/** Translated label for a condition type name from CONDITION_NAMES; other names pass through. */
export function getConditionNameLabel(name: string, t: Translate): string {
  const labels = new Map<string, string>([
    [
      CONDITION_NAMES[Condition.ADJUSTMENT_AMOUNT],
      t("Total adjustment amount"),
    ],
    [
      CONDITION_NAMES[Condition.AFTER_HOURS],
      t("Customer contacted after hours"),
    ],
    [CONDITION_NAMES[Condition.ASSIGNMENT_TYPE], t("Assignment")],
    [CONDITION_NAMES[Condition.CHANNEL], t("Return channel")],
    [CONDITION_NAMES[Condition.COLLECTION], t("Collections")],
    [CONDITION_NAMES[Condition.COMPARE_AT_PRICE], t("Compare-at price")],
    [CONDITION_NAMES[Condition.COMPENSATION_METHOD], t("Compensation method")],
    [
      CONDITION_NAMES[Condition.COVERAGE],
      t("Returns covered by {{brandName}}", { brandName: "Redo" }),
    ],
    [CONDITION_NAMES[Condition.CUSTOMER_ADDRESS], t("Customer address")],
    [CONDITION_NAMES[Condition.CUSTOMER_COUNTRY], t("Customer country")],
    [CONDITION_NAMES[Condition.CUSTOMER_EMAIL], t("Customer email")],
    [
      CONDITION_NAMES[Condition.CUSTOMER_EMAIL_SUBSCRIBER],
      t("Customer email subscriber"),
    ],
    [
      CONDITION_NAMES[Condition.CUSTOMER_SMS_SUBSCRIBER],
      t("Customer sms subscriber"),
    ],
    [CONDITION_NAMES[Condition.CUSTOMER_TAG], t("Customer tags")],
    [CONDITION_NAMES[Condition.DAMAGED], t("Damaged")],
    [CONDITION_NAMES[Condition.DELIVERY_WITHIN], t("Time since delivery")],
    [CONDITION_NAMES[Condition.DISCOUNT], t("Discounts")],
    [CONDITION_NAMES[Condition.DROPOFF_NEARBY], t("Drop-off nearby")],
    [
      CONDITION_NAMES[Condition.EXCHANGE_COUNT],
      t("Number of previous exchanges / is order an exchange"),
    ],
    [
      CONDITION_NAMES[Condition.EXTENDED_WARRANTY],
      t("Extended warranty is live on item"),
    ],
    [
      CONDITION_NAMES[Condition.EXTENDED_WARRANTY_PURCHASED],
      t("Extended warranty purchased"),
    ],
    [CONDITION_NAMES[Condition.FINAL_SALE_RETURN], t("Final sale return item")],
    [
      CONDITION_NAMES[Condition.FULFILLMENT_TRACKING_UPDATE_WITHIN],
      t("Time since last tracking update"),
    ],
    [
      CONDITION_NAMES[Condition.FULFILLMENT_WITHIN],
      t("Time since fulfillment"),
    ],
    [CONDITION_NAMES[Condition.IS_DELIVERED], t("Package delivered")],
    [CONDITION_NAMES[Condition.IS_GIFT_RETURN], t("Gift return")],
    [CONDITION_NAMES[Condition.IS_GREEN_RETURN], t("Green return")],
    [
      CONDITION_NAMES[Condition.IS_REFUND_RETURN],
      t("Requested refund on return"),
    ],
    [CONDITION_NAMES[Condition.IS_REPAIR], t("Is repair")],
    [CONDITION_NAMES[Condition.ITEM_DISCOUNT], t("Item discount")],
    [
      CONDITION_NAMES[Condition.ITEMS_BEING_RETURNED_COUNT],
      t("Number of items being returned"),
    ],
    [CONDITION_NAMES[Condition.LOCATION_NAME], t("Origin location name")],
    [CONDITION_NAMES[Condition.LOYALTY_EARNED], t("Loyalty")],
    [CONDITION_NAMES[Condition.MERCHANT_CREATED], t("Merchant created")],
    [CONDITION_NAMES[Condition.MESSAGE_BODY_MATCHES], t("Message body")],
    [CONDITION_NAMES[Condition.MULTIPLE_CHOICE], t("Multiple choice")],
    [CONDITION_NAMES[Condition.NON_RETURNED_VALUE], t("Non-returned value")],
    [
      CONDITION_NAMES[Condition.NUM_CUSTOMER_CLAIMS],
      t("Number of previous customer claims"),
    ],
    [
      CONDITION_NAMES[Condition.NUM_CUSTOMER_RETURNS],
      t("Number of previous customer returns"),
    ],
    [
      CONDITION_NAMES[Condition.NUM_ITEMS_IN_RETURN],
      t("Number of items in return"),
    ],
    [CONDITION_NAMES[Condition.NUM_ORDERS], t("Number of orders")],
    [
      CONDITION_NAMES[Condition.ORDER_COUNT_GREATER_THAN],
      t("Order count greater than"),
    ],
    [CONDITION_NAMES[Condition.ORDER_DATE], t("Order created date")],
    [CONDITION_NAMES[Condition.ORDER_NUMBER], t("Order number")],
    [CONDITION_NAMES[Condition.ORDER_TAG], t("Order tags")],
    [
      CONDITION_NAMES[Condition.ORDER_TIME_COLLECTION],
      t("Original collections at order time"),
    ],
    [CONDITION_NAMES[Condition.ORDER_WITHIN], t("Time since order")],
    [CONDITION_NAMES[Condition.ORDERLESS], t("Third Party Order")],
    [
      CONDITION_NAMES[Condition.PACKAGE_PROTECTION],
      t("Covered by package protection"),
    ],
    [CONDITION_NAMES[Condition.PAYMENT_METHOD], t("Original Payment Method")],
    [CONDITION_NAMES[Condition.PLATFORM], t("Platform")],
    [CONDITION_NAMES[Condition.PRICE], t("Pre-Discount Price")],
    [CONDITION_NAMES[Condition.PRODUCT_AVAILABLE], t("Product available")],
    [CONDITION_NAMES[Condition.PRODUCT_METAFIELD], t("Product metafield")],
    [CONDITION_NAMES[Condition.PRODUCT_PROPERTY], t("Product properties")],
    [CONDITION_NAMES[Condition.PRODUCT_TAG], t("Product tags")],
    [CONDITION_NAMES[Condition.PRODUCT_TYPE], t("Product type")],
    [
      CONDITION_NAMES[Condition.PRODUCT_VARIANT_METAFIELD],
      t("Product variant metafield"),
    ],
    [CONDITION_NAMES[Condition.PURCHASE_CHANNEL], t("Purchase Channel")],
    [CONDITION_NAMES[Condition.RECEIVED_AT_EMAIL], t("Email Received At")],
    [
      CONDITION_NAMES[Condition.REPLACEMENT_UNAVAILABLE],
      t("Replacement unavailable"),
    ],
    [CONDITION_NAMES[Condition.RETURN_DATE], t("Request created date")],
    [CONDITION_NAMES[Condition.RETURN_METHOD], t("Return method")],
    [CONDITION_NAMES[Condition.RETURN_RATE], t("Customer return rate")],
    [CONDITION_NAMES[Condition.RETURN_REASON], t("Return reason")],
    [
      CONDITION_NAMES[Condition.RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY],
      t("Bundle item being returned individually"),
    ],
    [CONDITION_NAMES[Condition.RETURN_TYPE], t("Return type")],
    [
      CONDITION_NAMES[Condition.RETURN_VALUE],
      t("Individual item price (deprecated)"),
    ],
    [CONDITION_NAMES[Condition.SALES_CHANNEL], t("Sales channel")],
    [CONDITION_NAMES[Condition.SENT_FROM_EMAIL], t("Email sent from")],
    [CONDITION_NAMES[Condition.SKU], t("SKU")],
    [CONDITION_NAMES[Condition.SUBJECT_LINE], t("Subject line")],
    [CONDITION_NAMES[Condition.TICKET_CHANNEL], t("Ticket channel")],
    [CONDITION_NAMES[Condition.TOPIC], t("Message topic")],
    [
      CONDITION_NAMES[Condition.TOTAL_PRE_DISCOUNT_PRICE],
      t("Total pre-discount price"),
    ],
    [CONDITION_NAMES[Condition.TOTAL_RETURN_VALUE], t("Total Return Value")],
    [
      CONDITION_NAMES[Condition.TOTAL_SPENT_GREATER_THAN],
      t("Total spent greater than"),
    ],
    [CONDITION_NAMES[Condition.TRACKING_TYPE], t("Tracking type")],
    [CONDITION_NAMES[Condition.VENDOR], t("Vendors")],
    [CONDITION_NAMES[Condition.WEEKLY_SCHEDULE], t("Weekly schedule")],
    [
      CONDITION_NAMES[Condition.WITHDRAWAL_EXCLUSION],
      t("Withdrawal exclusion"),
    ],
    [CONDITION_NAMES[Condition.WRONG_PRODUCT], t("Wrong product")],
  ]);
  return labels.get(name) ?? name;
}
